import React, { useEffect, useState } from "react";
import "./style.css";
import {
    Layout,
    Empty,
    Breadcrumb,
    Table,
    Button,
    Space,
    Input,
    Row,
    Col,
    Divider,
    Spin,
    Tabs,
} from "antd";
import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { SearchOutlined, SyncOutlined } from "@ant-design/icons";
import Container from "../Layout/Container";
import { getActivityLogs, ManageActivityLogSelector, clearState, } from './ManageActivitySlice';
import moment from 'moment';
const { Header, Content, Footer } = Layout;
const { Search } = Input;
const { TabPane } = Tabs;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const ntop = "none";
const nbottom = "bottomCenter";
const data = [
    {
        id: 1,
        user_name: "Homer Ryan",
        login: "Nov 1, 2021 3:25 PM",
        logout: "Nov 1, 2021 3:25 PM",

    },
];



export default function ManageActivity() {

    const dispatch = useDispatch();
    const [isLoading, setLoading] = React.useState(false);
    const [isToast, setToast] = React.useState(false);
    const [allActivityLogData, setDataSource] = useState([]);
    const [page, setPage] = useState(1);

    const { isFetching, isError, errorMessage, ActivityLogData, logCount, isActivityLogSuccess } = useSelector(
        ManageActivityLogSelector
    );


    useEffect(() => {
        setLoading(true);
        dispatch(clearState());
        dispatch(getActivityLogs(page));
    }, []);

    useEffect(() => {

        if (isError) {
            setLoading(false);
            setToast(true);
            toast.error(errorMessage);
        }
        if (isActivityLogSuccess) {
            setLoading(false);
            setDataSource(ActivityLogData);
        }
    }, [isError, isActivityLogSuccess, setLoading, ActivityLogData, logCount, setDataSource]);



    const renderContent = (value, row, index) => {
        const obj = {
            children: value,
            props: {},
        };
        return obj;
    };

    const columns = [
        {
            title: "User Name",
            dataIndex: "user_name",
            render: renderContent,
        },
        {
            title: "Api",
            dataIndex: "api",
            render: renderContent,
        },
        {
            title: "Time",
            dataIndex: "time",
            render: renderContent,
        }
    ];

    const handleChangeActivityLog = (v) => {

        setPage(v.current);
        dispatch(getActivityLogs(v.current));

    }


    let dataSource = isLoading
        ? []
        : allActivityLogData && allActivityLogData.length > 0 ? allActivityLogData.map(row => ({
            id: row._id,
            user_name: row.fullName,
            api: row.api,
            time: moment(row.time).format("lll"),

        })) : [];

    return (
        <>
            <Container>


                {isToast &&
                    <Toaster
                        toastOptions={{
                            className: '',
                            style: {
                                border: '1px solid #713200',
                                padding: '16px',
                                color: '#713200',
                                marginTop: 50
                            },
                        }}
                    >
                        {(t) => (
                            <ToastBar toast={t}>
                                {({ icon, message }) => (
                                    <>
                                        {icon}
                                        {message}
                                        {t.type !== 'loading' && (
                                            <button onClick={() => toast.dismiss(t.id)}>X</button>
                                        )}
                                    </>
                                )}
                            </ToastBar>
                        )}
                    </Toaster>
                }

                <div className="site-layout-content" style={{ marginTop: 5 }}>
                    <div style={{ padding: 24, paddingTop: 16 }}>
                        <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isLoading} />
                        <h2 style={{ backgroundColor: "#ffffff", paddingLeft: 16, paddingTop: 20, paddingBottom: 25, borderTop: '1px solid #dfe0eb', borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', marginBottom: 0 }}>Activity Log ({logCount ? logCount : 0})</h2>
                        <Space style={{ backgroundColor: "#ffffff", padding: 16, width: '100%', borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb' }} size="large">
                            {/* <Row style={{ width: '100%' }}>
                                <Col span="10">

                                    <Space style={{ width: '100%' }}>
                                        <Input placeholder="Search by user name" size="large" suffix={<SearchOutlined />} />

                                    </Space>


                                </Col>

                                <Col span="14" >
                                </Col>
                            </Row> */}


                        </Space>
                        <Table columns={columns}
                            onChange={handleChangeActivityLog}
                            pagination={{ position: [ntop, nbottom], size: 'small', total: logCount, hideOnSinglePage: true }}
                            dataSource={dataSource} bordered />
                    </div>

                </div>
            </Container>
        </>
    );
}
